import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FilterCompleteService } from 'src/app/filter-complete/filter-complete';
import { ClientFilter } from '../../../model/client-filter';
import { FilterRecordService } from '../../../services/filter-record.service';
import { IFilterComponent, SearchFilter } from '../../../infrastructure/iFilter-component';
import { ClientService } from '../../../services/client.service';
import { PreBillingService } from '../../../services/billing/pre-billing.service';
import { NotificationToastService } from '../../../services/notification-toast.service';

@Component({
  selector: 'app-pre-billing-filter',
  templateUrl: './pre-billing-filter.component.html',
  styleUrls: ['./pre-billing-filter.component.css']
})
export class PreBillingFilterComponent implements IFilterComponent, OnInit {

  form: FormGroup;
  @ViewChild('formElement', {static: false}) formElement: ElementRef;
  filterCompleteClients: FilterCompleteService<ClientFilter>;

  constructor( private formBuilder: FormBuilder,
               private notificationToastService: NotificationToastService,
               private clientService: ClientService,
               private preBillingService: PreBillingService,
               private filterRecordService: FilterRecordService ) {
    this.form = this.formBuilder.group({
      numberPreBill: [ '' ],
      client: [ null ],
      clientCode: [ '' ],
      from: [ '' ],
      to: [ '' ]
    });

    this.filterCompleteClients = new FilterCompleteService<ClientFilter>([], this.form.controls.client);
  }

  get f() { return this.form.controls; }
  get filteredClientsOptions() { return this.filterCompleteClients ? this.filterCompleteClients.filteredOptions : []; }

  ngOnInit() {
    this.clientService.getClientFilters().then((info) => {
      this.filterCompleteClients = new FilterCompleteService<ClientFilter>(info,
        this.form.controls.client);
    });
  }

  async saveFilters() {
    this.filterRecordService.saveFilters('PreBillingFilterComponent', this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('PreBillingFilterComponent', this.form);
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async search(): Promise<any> {
    if ( !this.existsFilter() ) {
      this.notificationToastService.error('Debe seleccionar al menos un filtro', 'Generar factura');
      return [];
    } else {
    const items =  await this.preBillingService.getBillingClosePreBillings(
      (this.form.controls.clientCode.value ? this.form.controls.clientCode.value : ''),
      (this.form.controls.numberPreBill.value ? this.form.controls.numberPreBill.value : null),
      (this.form.controls.client.value ? this.form.controls.client.value.Id : null),
      (this.form.controls.from.value ? <Date>this.form.controls.from.value : null),
      (this.form.controls.to.value ? <Date>this.form.controls.to.value : null));
      return items;
    }
  }

  existsFilter(): boolean {
    return  this.form.controls.clientCode.value ||
            this.form.controls.numberPreBill.value ||
            this.form.controls.client.value ||
            this.form.controls.from.value ||
            this.form.controls.to.value;
  }
}
